import classnames from "classnames";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Had to disable this to populate content in description column.
// eslint-disable-next-line @bigbinary/neeto/no-dumb-components-with-use-translation
const MobilePreviewHeader = ({ className = "", message = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classnames(["neeto-ui-bg-gray-200 px-6 py-5", className])}
      data-testid="mobile-preview-header"
    >
      <Typography lineHeight="normal" style="body2">
        {message || t("neetoMolecules.mobilePreview.message")}
      </Typography>
    </div>
  );
};

MobilePreviewHeader.propTypes = {
  /**
   * To provide additional classes
   */
  className: PropTypes.string,
  /**
   * To provide custom message.
   */
  message: PropTypes.node,
};

export default MobilePreviewHeader;
